import { t } from 'i18n';
import React, { ReactNode } from 'react';
import {
  BuildPcOutlined,
  HeadphoneOutlined,
  ShowroomOutlined,
  TvNewOutlined,
} from '@teko/ds-icon';
import { TopbarButton } from '@teko/teko-ecommerce';
import { LanguageSelector } from 'components/desktop/organisms';
// TODO: remove this dependency
const supportedPhone = '1800 6865';
const clientConsultantPhone = '1800 6867';

export const getRightMenu = (): Array<ReactNode> => [
  <TopbarButton
    key={1}
    href="/contact"
    icon={<ShowroomOutlined color="white" size={18} />}
    tracking={{
      isTrackContent: true,
      regionName: 'taskbar',
      contentName: 'showroomListURL',
    }}
  >
    {t('Hệ thống Showroom')}
  </TopbarButton>,
  <TopbarButton
    key={2}
    href={`tel:${clientConsultantPhone.split(' ').join('')}`}
    icon={<HeadphoneOutlined color="white" size={18} />}
    tracking={{
      isTrackContent: true,
      regionName: 'taskbar',
      contentName: 'hotlineSupportURL',
    }}
  >
    {t('Tư vấn mua hàng:')}{' '}
    <span className="highlight">{clientConsultantPhone}</span>
  </TopbarButton>,
  <TopbarButton
    key={3}
    href={`tel:${supportedPhone.split(' ').join('')}`}
    icon={<HeadphoneOutlined color="white" size={18} />}
    tracking={{
      isTrackContent: true,
      regionName: 'taskbar',
      contentName: 'hotlineSupportURL',
    }}
  >
    {t('CSKH')}: <span className="highlight">{supportedPhone}</span>
  </TopbarButton>,
  <TopbarButton
    key={4}
    href="https://phongvu.vn/cong-nghe/"
    icon={<TvNewOutlined color="white" size={18} />}
    tracking={{
      isTrackContent: true,
      regionName: 'taskbar',
      contentName: 'techNewsURL',
    }}
  >
    {t('Tin công nghệ')}
  </TopbarButton>,
  <TopbarButton
    key={5}
    href="/buildpc"
    icon={<BuildPcOutlined color="white" size={18} />}
    tracking={{
      isTrackContent: true,
      regionName: 'taskbar',
      contentName: 'buildpcURL',
    }}
  >
    {t('Xây dựng cấu hình')}
  </TopbarButton>,
  <LanguageSelector key={6} />,
];

export const getFooterData = () => ({
  supportAndPolicy: [
    {
      title: t('Hỗ trợ khách hàng'),
      links: [
        {
          children: t('Thẻ ưu đãi'),
          href: 'https://help.phongvu.vn/dich-vu-khach-hang/the-thanh-vien',
          target: '_blank',
          rel: 'noreferrer noopener',
        },
        {
          children: t('Trung tâm bảo hành'),
          href: 'https://help.phongvu.vn/chinh-sach-ban-hang/bao-hanh#trung-tam-bao-hanh-phong-vu',
          target: '_blank',
          rel: 'noreferrer noopener',
        },
        {
          children: t('Thanh toán và giao hàng'),
          href: 'https://help.phongvu.vn/chinh-sach-ban-hang/phuong-thuc-thanh-toan',
          target: '_blank',
          rel: 'noreferrer noopener',
        },
        {
          children: t('Dịch vụ sửa chữa và bảo trì'),
          href: 'https://help.phongvu.vn/dich-vu-khach-hang/dich-vu-sua-chua-va-bao-tri',
          target: '_blank',
          rel: 'noreferrer noopener',
        },
        {
          children: t('Doanh nghiệp thân thiết'),
          href: 'https://help.phongvu.vn/dich-vu-khach-hang/doanh-nghiep-than-thiet',
          target: '_blank',
          rel: 'noreferrer noopener',
        },
      ],
    },
    {
      title: t('Chính sách Mua hàng và Bảo hành'),
      links: [
        {
          children: t('Quy định chung'),
          href: 'https://help.phongvu.vn/chinh-sach-ban-hang/',
          target: '_blank',
          rel: 'noreferrer noopener',
        },
        {
          children: t('Chính sách Bảo mật Thông tin'),
          href: 'https://help.phongvu.vn/chinh-sach-chung/bao-mat-thong-tin',
          target: '_blank',
          rel: 'noreferrer noopener',
        },
        {
          children: t('Chính sách Vận chuyển và Lắp đặt'),
          href: 'https://help.phongvu.vn/chinh-sach-ban-hang/van-chuyen-va-lap-dat',
          target: '_blank',
          rel: 'noreferrer noopener',
        },
        {
          children: t('Chính sách bảo hành'),
          href: 'https://help.phongvu.vn/chinh-sach-ban-hang/bao-hanh',
        },
        {
          children: t('Chính sách đổi trả và hoàn tiền'),
          href: 'https://help.phongvu.vn/chinh-sach-ban-hang/doi-tra-va-hoan-tien',
          target: '_blank',
          rel: 'noreferrer noopener',
        },
        {
          children: t('Quy định giá cả và hình thức thanh toán'),
          href: 'https://help.phongvu.vn/chinh-sach-chung/gia-ca-va-hinh-thuc-thanh-toan',
          target: '_blank',
          rel: 'noreferrer noopener',
        },
        {
          children: t('Chính sách trả góp'),
          href: 'https://help.phongvu.vn/chinh-sach-ban-hang/tra-gop',
          target: '_blank',
          rel: 'noreferrer noopener',
        },
      ],
    },
    {
      title: t('Thông tin Phong Vũ'),
      links: [
        {
          children: t('Giới thiệu Phong Vũ'),
          href: 'https://help.phongvu.vn/',
          target: '_blank',
          rel: 'noreferrer noopener',
        },
        {
          children: t('Thông tin liên hệ'),
          href: '/contact',
        },
        {
          children: t('Hệ thống Showroom'),
          href: '/contact',
        },
        {
          children: t('Hỏi đáp'),
          href: 'https://phongvu.vn/hoi-dap',
        },
        {
          children: t('Tin công nghệ'),
          href: 'https://phongvu.vn/cong-nghe',
        },
        {
          children: t('Tuyển dụng'),
          href: 'https://help.phongvu.vn/ho-tro/tuyen-dung',
          target: '_blank',
          rel: 'noreferrer noopener',
        },
      ],
    },
    {
      title: t('Cộng đồng Phong Vũ'),
      links: [
        {
          icon: { name: 'logo-facebook', size: 16, color: '#485992' },
          children: t('Phong Vũ Việt Nam'),
          href: 'https://phongvu.page.link/fanpage',
        },
        {
          icon: { name: 'logo-youtube', size: 16, color: '#cf2200' },
          children: 'Phong Vũ Media',
          href: 'https://www.youtube.com/channel/UCOJ3sqWCc6koR9BScBZkBlA',
        },
        {
          icon: { name: 'community', size: 16, color: '#00AFF7' },
          children: t('Phong Vũ Hội'),
          href: 'https://phongvu.page.link/congdong',
        },
        {
          icon: { name: 'support', size: 16, color: '#333333' },
          children: (
            <span>
              {t('Gọi Mua hàng:')}{' '}
              <span
                style={{
                  color: '#DA4343',
                  fontWeight: 'bold',
                }}
              >
                {clientConsultantPhone}
              </span>{' '}
              {t('(miễn phí)')}
            </span>
          ),
          href: `tel:${clientConsultantPhone.split(' ').join('')}`,
        },
        {
          icon: { name: 'support', size: 16, color: '#333333' },
          children: (
            <span>
              {t('Gọi Chăm sóc:')}{' '}
              <span
                style={{
                  color: '#DA4343',
                  fontWeight: 'bold',
                }}
              >
                {supportedPhone}
              </span>{' '}
              {t('(miễn phí)')}
            </span>
          ),
          href: `tel:${supportedPhone.split(' ').join('')}`,
        },
      ],
    },
    {
      title: t('Email liên hệ'),
      emails: [
        {
          children: t('Hỗ trợ Khách hàng:<br/>'),
          address: 'cskh@phongvu.vn',
        },
        {
          children: t('Liên hệ báo giá:<br/>'),
          address: 'baogia@phongvu.vn',
        },
        {
          children: t('Hợp tác phát triển:<br/>'),
          address: 'hoptac@phongvu.vn',
        },
      ],
    },
  ],
  paymentMethods: {
    title: t('Phương thức thanh toán'),
    links: [
      {
        icon: { name: 'qr-code', size: 30, color: '#3e3e3e' },
        children: 'QR Code',
        href: 'https://help.phongvu.vn/chinh-sach-ban-hang/huong-dan-thanh-toan-vnpay-qr',
        link: true,
      },
      {
        icon: { name: 'cash', size: 30, color: '#3e3e3e' },
        children: t('Tiền mặt'),
        href: 'https://help.phongvu.vn/chinh-sach-ban-hang/phuong-thuc-thanh-toan#thanh-toan-tien-mat',
        link: true,
      },
      {
        icon: { name: 'time', size: 30, color: '#3e3e3e' },
        children: t('Trả góp'),
        href: 'https://help.phongvu.vn/chinh-sach-ban-hang/phuong-thuc-thanh-toan#thanh-toan-tra-gop',
        link: true,
      },
      {
        icon: { name: 'card', size: 30, color: '#3e3e3e' },
        children: 'Internet Banking',
        href: 'https://help.phongvu.vn/chinh-sach-ban-hang/phuong-thuc-thanh-toan#thanh-toan-the-atm-noi-dia-internet-banking',
        link: true,
      },
    ],
  },
  bankList: {
    imgSrc: 'https://phongvu.vn/media/wysiwyg/phongvu/phongvu_v3/banklist.jpg',
    mobileImgSrc:
      'https://phongvu.vn/skin/frontend/default/pv_mob_amp/images/phongvu-v4/mobile-bank-list.png',
  },
  bottom: {
    company: {
      name: t('phongvu.desktop._module.Layout.data.0'),
      detail: t('phongvu.desktop._module.Layout.data.1'),
    },
    address: [
      {
        branchName: t('Địa chỉ trụ sở chính'),
        branchAddress: t('phongvu.desktop._module.Layout.data.2'),
      },
      {
        branchName: t('Văn phòng điều hành miền Bắc'),
        branchAddress: t('phongvu.desktop._module.Layout.data.3'),
      },
      {
        branchName: t('Văn phòng điều hành miền Nam'),
        branchAddress: t('phongvu.desktop._module.Layout.data.4'),
      },
    ],
    verifiedLogo: {
      logo: 'https://phongvu.vn/media/wysiwyg/phongvu/phongvu_v3/da-dang-ky.png',
      link: 'http://online.gov.vn/Home/WebDetails/4549',
    },
    dmcaId: '53b44883-ed2a-434d-902b-5adce10aafd5',
    dmcaBadgeLink: 'https://images.dmca.com/Badges/dmca-badge-w100-2x1-02.png',
  },
});
